var React = require('react');

function ArrowRightCurveInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M4 12L22.4 12","stroke":"current","strokeWidth":"1.3","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M16.8008 6.39844C16.8008 6.39844 17.7965 8.72774 18.9123 9.84355C20.0281 10.9594 22.3574 11.9551 22.3574 11.9551","stroke":"current","strokeWidth":"1.3","strokeLinecap":"round","strokeLinejoin":"round","key":1}),React.createElement("path",{"d":"M16.7988 17.5586C16.7988 17.5586 17.7945 15.2293 18.9104 14.1135C20.0262 12.9977 22.3555 12.002 22.3555 12.002","stroke":"current","strokeWidth":"1.3","strokeLinecap":"round","strokeLinejoin":"round","key":2})]);
}

ArrowRightCurveInline.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = ArrowRightCurveInline;

ArrowRightCurveInline.default = ArrowRightCurveInline;
